import { ACTION_LOG_TYPE } from "Common/dictionaries/actionLogType";
import Button from "Components/button";
import ProgressOverlay from "Components/progressOverlay";
import { Tab, Tabs } from "Components/tabs";
import classNames from "classnames";
import findIndex from "lodash/findIndex";
import map from "lodash/map";
import React, { useMemo, useRef, useState } from "react";
import ActionGrid from "./actionGrid";
import locale from "./actionLog.locale";
const tabs = [
    {
        logType: ACTION_LOG_TYPE.SYSTEM_ACCESS,
        title: locale.SYSTEM_ACCESS
    },
    {
        logType: ACTION_LOG_TYPE.ADMIN_ACTIONS,
        title: locale.ADMIN_ACTIONS
    },
    {
        logType: ACTION_LOG_TYPE.USER_ACTIONS,
        title: locale.USER_ACTIONS
    }
];
export default function ActionLog(props) {
    const [hasDataOpts, setHasDataOpts] = useState({
        hasData: false,
        options: undefined
    });
    const gridRef = useRef(null);
    function ActionPanel({ type, disabled }) {
        return (React.createElement(Button, { disabled: disabled, text: locale.EXPORT, onClick: () => {
                if (!(hasDataOpts === null || hasDataOpts === void 0 ? void 0 : hasDataOpts.options) || !props.onExport)
                    return;
                props.onExport(type, hasDataOpts.options.filter, hasDataOpts.options.sort);
            }, height: 36 }));
    }
    const tabsPanel = useMemo(() => (React.createElement(Tabs, { onTabChange: (index) => props.onActionLogTypeChange && props.onActionLogTypeChange(tabs[index].logType), selectedTabIndex: findIndex(tabs, ["logType", props.actionLogType]), flex: true }, map(tabs, item => [
        React.createElement(Tab, { rightPanel: React.createElement(ActionPanel, { type: props.actionLogType, disabled: !(hasDataOpts === null || hasDataOpts === void 0 ? void 0 : hasDataOpts.hasData) }), title: item.title, key: `tab-${item.logType}` })
    ]))), [props.actionLogType, hasDataOpts]);
    return (React.createElement("div", { className: classNames("panel-body-padding stretched-to-fit", props.className) },
        React.createElement(ProgressOverlay, { show: props.inProgress },
            React.createElement("div", { className: "flex-single-column with-grid-spaces" },
                React.createElement("h2", { className: "font-bold" }, locale.ACTION_LOG),
                tabsPanel,
                React.createElement("div", { className: "flex-greedy-block p-0_75" },
                    React.createElement(ActionGrid, { gridRef: gridRef, onHasDataChanged: setHasDataOpts, type: props.actionLogType }))))));
}
